import {GET, POST} from '../index'

// 合作伙伴列表
export const partnerPage = (data) => {
  return GET('partner/page', data)
}
// 添加合作伙伴
export const partnerAdd = (data) => {
  return POST('partner/add', data)
}

// 合作伙伴删除
export const partnerDel = (data) => {
  return POST('partner/del', data)
}

// 合作伙伴排序
export const partnerSequence = (data) => {
  return POST('partner/sequence', data)
}



// WEBPACK FOOTER //
// ./src/api/partner/index.js